import { Col, Row, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import { getUserStatus } from "../../../models/user/enum";
import { getBannerType } from "../../../models/banner-campaign/enum";
import CategoryContext from "../../../context/category/context";
import BannerCategoryContext from "../../../context/banner-category/context";
import { ICampaign } from "../../../models/campaign/response";
import EndPoints from "../../../services/end-points";
import AppContext from "../../../context/app/context";
import { ICategory } from "../../../models/category/response";
interface IProps {}

const BannerCategoryFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(BannerCategoryContext);
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [categoryLoading, setCategoryLoading] = useState<boolean>(true);
  const statuses = [1, 2];
  const { direction } = useContext(AppContext);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const { data } = await EndPoints.category.getAllCategories({
          light: true,
          perPage: -1,
        });
        const newOptions = data?.data;
        setCategories((prevOptions) => [...prevOptions, ...newOptions]);
      } catch (error) {
      } finally {
        setCategoryLoading(false);
      }
    };
    getCategories();
  }, [direction]);
  return (
    <Form
      formId="category-banner-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.status
              ? {
                  name: "status",
                  value: data.status,
                  operation: "eq",
                }
              : undefined,
            data?.type
              ? {
                  name: "type",
                  value: data.type,
                  operation: "eq",
                }
              : undefined,
              data?.category_id
                ? {
                    name: "categoryId",
                    value: data.category_id,
                    operation: "eq",
                  }
                : undefined,
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col span={8}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: statuses.map((status, index) => {
                return {
                  label: t(getUserStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col span={8}>
          <FieldBuilder
            name="type"
            label={`${t("type")}`}
            width="large"
            input={{
              type: "select",
              options: [1, 2, 3, 4, 5].map((status, index) => {
                return {
                  label: t(getBannerType(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col span={8}>
              <FieldBuilder
                name="category_id"
                label={`${t("category")}`}
                width="large"
                input={{
                  type: "select",
                  allowSearch: true,
                  options: categories?.map((cat, index) => {
                    return {
                      key: index,
                      label: cat.name,
                      value: cat.id,
                    };
                  }),
                }}
              />
        </Col>

      </Row>
    </Form>
  );
};

export default BannerCategoryFilter;
